import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/home/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },

  {path: '/prueba', name: 'prueba', component: () => import('../views/prueba.vue')},

  // RUTAS DE LA SECCIÓN DE CONOCENOS -> Secretaria de hacienda
  {
    path: '/conocenos',
    name: 'conocenos',
    component: () => import(/* webpackChunkName: "servcio-contribuyente" */ '../views/conocenos/Conocenos.vue'),
    children: [
      /****Conocenos/Secretaria-de-hacienda* */
      {path: 'secretaria-de-hacienda', name:'secretaria-de-hacienda', component: () => import('../views/conocenos/SecretariaHacienda/OpcSecretariaHacienda.vue') },
      {path: 'secretaria-de-hacienda/mision-vision', name:'conocenos-mision-vision', component: () => import('../views/conocenos/SecretariaHacienda/MisionVision.vue') },
      {path: 'secretaria-de-hacienda/reglamento-interior', name:'conocenos-reglamento-interior', component: () => import('../views/conocenos/SecretariaHacienda/reglamentoInterior.vue') },
      {path: 'secretaria-de-hacienda/programas-institucionales', name:'conocenos-programas-institucionales', component: () => import('../views/conocenos/SecretariaHacienda/programasInstitucionales.vue') },
      {path: 'secretaria-de-hacienda/indicadores-de-gestion', name:'conocenos-indicadores-de-gestion', component: () => import('../views/conocenos/SecretariaHacienda/IndicadoresGestion.vue') },
      {path: 'secretaria-de-hacienda/organigrama', name:'conocenos-organigrama', component: () => import('../views/conocenos/SecretariaHacienda/Organigrama.vue') },
      {path: 'secretaria-de-hacienda/directorio', name:'conocenos-directorio', component: () => import('../views/conocenos/SecretariaHacienda/Directorio.vue') },
      /// IMPORTANTE DIRECTORIO DE PRUEBA
      // {path: 'secretaria-de-hacienda/directorio2', name:'conocenos-directorio-secretaria-de-hacienda', component: () => import('../views/conocenos/SecretariaHacienda/directorio-organosAdmin.vue') },
      {path: 'secretaria-de-hacienda/directorioSH', name:'conocenos-directorio-secretaria-de-hacienda', component: () => import('../views/conocenos/SecretariaHacienda/directorio-organosAdmin.vue') },

       /****Conocenos/manuales-administrativos* */
       {path: 'manuales-administrativos', name:'manuales-administrativos', component: () => import(/* webpackChunkName: "servcio-contribuyente" */ '../views/conocenos/ManualesAdministrativos/OpcManualesAdmin.vue'),},
       {path: 'manuales-administrativos/manual-de-induccion', name:'conocenos-manual-de-induccion', component: () => import(/* webpackChunkName: "servcio-contribuyente" */ '../views/conocenos/ManualesAdministrativos/ManualInduccion.vue') },
       {path: 'manuales-administrativos/manual-de-organizacion', name:'conocenos-manual-de-organizacion' , component: () => import(/* webpackChunkName: "servcio-contribuyente" */ '../views/conocenos/ManualesAdministrativos/ManualOrganizacion.vue') },
       {path: 'manuales-administrativos/manual-de-procedimientos', name:'conocenos-manual-de-procedimientos', component: () => import(/* webpackChunkName: "servcio-contribuyente" */ '../views/conocenos/ManualesAdministrativos/ManualProcedimientos.vue') },
      //  {path: 'manuales-administrativos/tramites-servicios',  name: 'tramites-servicios', component: () => import('../views/conocenos/ManualesAdministrativos/TramiteServicios.vue') },
      //  {path: 'manuales-administrativos/cedula-servicio/:idTramite/token=:token?', name: 'cedula-servicio', component: () => import('../views/conocenos/ManualesAdministrativos/cedulaTramite.vue')},

       /******  Conocenos/Integridad Pública *******/
       {path: 'integridad-publica', name:'integridadPublica', component: () => import('../views/conocenos/integridadPublica/integridadOpciones.vue'),},

  ]
  },

  //======================================================
  ///Trámites y servicios
  {path: '/tramites-servicios',  name: 'tramites-servicios', component: () => import('../views/conocenos/ManualesAdministrativos/TramiteServicios2.vue') },
  {path: '/cedula-servicio/:idTramite', name: 'cedula-servicio', component: () => import('../views/conocenos/ManualesAdministrativos/TramiteServicios2.vue') }, // import('../views/conocenos/ManualesAdministrativos/cedulaTramite.vue')},


  //=============================
  {
    path: '/servicio-contribuyente',
    name: 'servicio-contribuyente',
    component: () => import(/* webpackChunkName: "conocenos" */ '../views/Servicio-contribuyente.vue')
  },
  {
    path: '/legislacion',
    name: 'legislacion',
    component: () => import(/* webpackChunkName: "legislacion" */ '../views/legislacion/Legislacion.vue'),
    children: [
      // /legislacion/municipal
      {path: 'municipal', name:'municipal', component: () => import(/* webpackChunkName: "legislacion" */ '../views/legislacion/municipal/OpcMunicipal.vue') },
      {path: 'municipal/leyes', name:'municipal-leyes', component: () => import(/* webpackChunkName: "legislacion" */ '../views/legislacion/municipal/leyes.vue') },
      {path: 'municipal/ley-de-ingreso-municipal', name:'municipal-ley-de-ingreso-municipal', component: () => import(/* webpackChunkName: "legislacion" */ '../views/legislacion/municipal/leyIngresoMpal.vue') },
      {path: 'municipal/otros', name:'municipal-otros',component: () => import(/* webpackChunkName: "legislacion" */ '../views/legislacion/municipal/otros.vue') },
      // /legislacion/estatal
      {path: 'estatal', name:'estatal', component: () => import(/* webpackChunkName: "legislacion" */ '../views/legislacion/estatal/OpcEstatal.vue') },
      {path: 'estatal/leyes-y-decretos', name:'estatal-leyes-y-decretos', component: () => import(/* webpackChunkName: "legislacion" */ '../views/legislacion/estatal/Leyes-decretos.vue') },
      {path: 'estatal/acuerdos', name:'estatal-acuerdos', component: () => import(/* webpackChunkName: "legislacion" */ '../views/legislacion/estatal/Acuerdos.vue') },
      {path: 'estatal/acuerdos/historico', name:'estatal-acuerdos-historico', component: () => import(/* webpackChunkName: "legislacion" */ '../views/legislacion/estatal/historico.vue') },
      {path: 'estatal/normas', name:'estatal-normas', component: () => import(/* webpackChunkName: "legislacion" */ '../views/legislacion/estatal/Normas.vue') },
      {path: 'estatal/reglamentos-y-lineamientos', name:'estatal-reglamentos-y-lineamientos', component: () => import(/* webpackChunkName: "legislacion" */ '../views/legislacion/estatal/Reglamentos-lineamientos.vue') },
      {path: 'estatal/convenios-y-otros', name:'estatal-convenios-y-otros', component: () => import(/* webpackChunkName: "legislacion" */ '../views/legislacion/estatal/Convenios-otros.vue') },
      {path: 'estatal/cursos-y-talleres-de-capacitacion', name:'estatal-cursos-y-talleres-de-capacitacion', component: () => import(/* webpackChunkName: "legislacion" */ '../views/legislacion/estatal/Cursos-talleres.vue') },


      // /legislacion/federal
      {path: 'federal', name:'federal', component: () => import(/* webpackChunkName: "legislacion" */ '../views/legislacion/federal/opcFederal.vue') },
      {path: 'federal/leyes', name:'federal-leyes', component: () => import(/* webpackChunkName: "legislacion" */ '../views/legislacion/federal/leyes.vue') },
      {path: 'federal/decretos', name:'federal-decretos', component: () => import(/* webpackChunkName: "legislacion" */ '../views/legislacion/federal/decretos.vue') },
      {path: 'federal/acuerdos', name:'federal-acuerdos', component: () => import(/* webpackChunkName: "legislacion" */ '../views/legislacion/federal/acuerdos.vue') },
      {path: 'federal/reglamentos', name:'federal-reglamentos', component: () => import(/* webpackChunkName: "legislacion" */ '../views/legislacion/federal/reglamentos.vue') },
      {path: 'federal/reglas', name:'federal-reglas', component: () => import(/* webpackChunkName: "legislacion" */ '../views/legislacion/federal/reglas.vue') },
      {path: 'federal/lineamientos', name:'federal-lineamientos', component: () => import(/* webpackChunkName: "legislacion" */ '../views/legislacion/federal/lineamientos.vue') },
      {path: 'federal/disposiciones-conac', name:'federal-disposiciones-conac', component: () => import(/* webpackChunkName: "legislacion" */ '../views/legislacion/federal/disposiciones.vue') },


      // /legislacion/periodico
      {path: 'periodico-oficial', name:'legislacion-periodico-oficial', component: () => import(/* webpackChunkName: "legislacion" */ '../views/legislacion/periodicoOficial/PeriodicoOficial.vue') },

    ]
  },
  {
    path: '/rendicion-de-cuentas',
    name: 'rendicion-de-cuentas',
    component: () => import(/* webpackChunkName: "legislacion" */ '../views/rendicionDeCuentas/rendicion-de-cuentas.vue')
  },
  {
    path: '/planeacion',
    name: 'planeacion',
    component: () => import(/* webpackChunkName: "legislacion" */ '../views/planeacion/planeacion.vue')
  },
  {
    path: '/funcionarios',
    name: 'funcionarios',
    component: () => import(/* webpackChunkName: "funcionarios" */ '../views/funcionarios/HomeFuncionarios.vue')
  },
  {
    path: '/transparencia',
    name: 'transparencia',
    component: () => import(/* webpackChunkName: "funcionarios" */ '../views/transparencia/transparencia.vue')
  },
  /***Enlaces de interes */
  {
    path: '/enlaces-de-interes',
    name: 'enlaces-de-interes',
    component: () => import(/* webpackChunkName: "funcionarios" */ '../views/home/enlaces-de-interes.vue')
  },

  {
    path: '/pago-contribuciones',
    name: 'pago-contribuciones',
    component: () => import(/* webpackChunkName: "funcionarios" */ '../views/home/pago-contribuciones.vue')
  },
/********PROBANDO ARCHIVOS DE PRUEBA DE SERVICIOS RUTAS DE PRUEBA!!!!!*********** */
{
  path: '/servicios',
  name: 'servicios',
  component: () => import(/* webpackChunkName: "servicios" */ '../views/Tramites/tramites.vue')
},
//*****Ruta que consulta el detalle de la cedula pero con el json */
//  {
//    path: '/cedula-servicio/:idTramite',
//    name: 'cedula-servicios',
//    component: () => import(/* webpackChunkName: "nombreTramite" */ '../views/Tramites/cedulaTramite.vue')
//  },
////**Ruta que consulta el detalle de la cedula con el servicio////
 {
   path: '/cedula-servicio2/:idTramite/token=:token',
   name: 'cedula-servicios',
   component: () => import(/* webpackChunkName: "nombreTramite" */ '../views/Tramites/cedulaTramite.vue')
 },
///////////**************************************/////////////////////////////////////
/////********Aviso de privacidad */
{
  path: '/aviso-de-privacidad',
  name: 'aviso-de-privacidad',
  component: () => import(/* webpackChunkName: "nombreTramite" */ '../views/avisoPrivacidad/avisoPrivacidad.vue')
},

//| SALA DE PRENSA |\\
{
  path: '/prensa',
  name: 'prensa',
  component: () => import('../views/sala-de-prensa/SalaPrensa.vue'),
  children: [
    {path: '/prensa/vista-listado/:filtros?', name: 'listado', component: () => import('../views/sala-de-prensa/VistaListado.vue')},
    // {path: '/prensa/vista-detalle/:id?', name: 'detalle',component: () => import('../views/sala-de-prensa/VistaDetalle.vue')},
    {path: '/prensa/vista-detalle/:id?/:titular?', name: 'detalle',component: () => import('../views/sala-de-prensa/VistaDetalle.vue')}
  ]
},
{
  path: '/foprovep',
  name: 'foprovep',
  component: () => import('../views/foprovep/homeFoprovep.vue'),
  children: [
    {path: '/foprovep/menu-principal', name: 'menuQuienesSomos', component: () => import('../views/foprovep/menuPrincipal.vue')},

    {path: '/foprovep/quienesSomos', name: 'quienesSomos', component: () => import('../views/foprovep/quienessomos/quienes_somos.vue')},
    {path: '/foprovep/quienesSomos/somosFoprovep', name: 'somosfoprovep', component: () => import('../views/foprovep/quienessomos/foprovep.vue')},
    {path: '/foprovep/quienesSomos/mision-vision', name: 'mision-vision', component: () => import('../views/foprovep/quienessomos/misionVision.vue')},
    {path: '/foprovep/quienesSomos/organigrama', name: 'organigrama', component: () => import('../views/foprovep/quienessomos/organigrama.vue')},
    {path: '/foprovep/quienesSomos/proposito-areas', name: 'proposito-areas', component: () => import('../views/foprovep/quienessomos/propositoAreas.vue')},
    {path: '/foprovep/quienesSomos/comite-tecnico', name: 'comite-tecnico', component: () => import('../views/foprovep/quienessomos/comiteTecnico.vue')},

    ///Rutas sección información
    {path: '/foprovep/informacion', name: 'informacion', component: () => import('../views/foprovep/informacion/informacion.vue')},
    {path: '/foprovep/informacion/coberturas', name: 'coberturas', component: () => import('../views/foprovep/informacion/coberturas.vue') },
    {path: '/foprovep/informacion/exclusion-de-coberturas', name: 'exclusion-de-coberturas', component: () => import('../views/foprovep/informacion/exclusion_cobertura.vue') },
    {path: '/foprovep/informacion/validez-de-aseguramiento', name: 'validez-de-aseguramiento', component: () => import('../views/foprovep/informacion/validez_aseguramiento.vue') },
    {path: '/foprovep/informacion/siniestro', name: 'siniestro', component: () => import('../views/foprovep/informacion/siniestro.vue') },
    {path: '/foprovep/informacion/primas-de-aseguramiento', name: 'primas-de-aseguramiento', component: () => import('../views/foprovep/informacion/primas-aseguramiento.vue') },
    {path: '/foprovep/informacion/ajustadores-autorizados', name: 'ajustadores-autorizados', component: () => import('../views/foprovep/informacion/ajustadores_autorizados.vue') },

    {path: '/foprovep/otrosDocumentos', name: 'otros', component: () => import('../views/foprovep/otros/otrosDocumentos.vue')},
    {path: '/foprovep/otrosDocumentos/informacion-contable', name: 'informacion-contable', component: () => import('../views/foprovep/otros/informacionContable.vue')},
    {path: '/foprovep/otrosDocumentos/formatos-dependencia', name: 'formatos-dependencia', component: () => import('../views/foprovep/otros/formatos.vue')},
    {path: '/foprovep/otrosDocumentos/reglas-operacion', name: 'reglas-operacion', component: () => import('../views/foprovep/otros/reglasOperacion.vue')}

  ]
},
//////////MODULO DE BECAS///////////////
{
  path: '/becas-a-servidores-publicos',
  name: 'becas-a-servidores-publicos',
  component: () => import(/* webpackChunkName: "nombreTramite" */ '../views/becasServidoresPublicos/becasServidoresPublicos.vue')
},

// --- Tramites de api de planeación ---
{
  path: '/modulo-planeacion',
  name: 'modulo-planeacion',
  component: () => import('../views/TramitesHacienda/planeacion.vue')
},
{
  path: '/modulo-planeacion/manual-de-formatos',
  name: 'manual-de-formatos',
  component: () => import('../views/TramitesHacienda/vistas_planeacion/manual_formatos.vue')
},
{
  path: '/modulo-planeacion/curso-de-Capacitacion',
  name: 'curso-de-Capacitacion',
  component: () => import('../views/TramitesHacienda/vistas_planeacion/curso-de-Capacitacion.vue')
},
{
  path: '/login-registro',
  name: 'loginRegistro',
  component: () => import('../views/TramitesHacienda/loginRegistro.vue')
},
{
  path: '/TramitesHacienda',
  name: 'TramitesHacienda',
  component: () => import('../views/TramitesHacienda/tramites.vue')
},
{
  path: '/TramitesHaciendaExternos',
  name: 'TramitesHaciendaExternos',
  component: () => import('../views/TramitesHacienda/tramitesExternos/tramitesExternos.vue')
},

  /* ---- ESTA RUTA DEBE SER LA ULTIMA ---- */
  {
    path: '*',
    name: '404',
    component: () => import('../views/404.vue')
  },

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
